// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"744b9348","264":"3371742c","418":"07059832","480":"81cb1fa7","638":"1a5a21ea","854":"d122c922"}[chunkId] + ".chunk.js";
};